import React, { Component, StrictMode, useEffect } from "react";
import ReactDOM from 'react-dom/client';
import { useSelector, useDispatch } from "react-redux";
import DateFormater from '../../chat/Component/DateFormater';
import SystemMessage from "./SystemMessage";
import { useTranslation } from 'react-i18next';
import { LinkItUrl } from 'react-linkify-it';
import File from './File';
import FileImagePreview from './FileImagePreview';
import ActionButtons from "./ActionButtons";

const Message = ({message}) => {
  
  const { t, i18n } = useTranslation();

  if (message.type == 2) {
    return <SystemMessage key={message.id} message = {message} />;
  }

  const hasImage = () => {
    let hasImage = false;
    if (message.files.length == 0) {
      return hasImage
    }

    message.files.map((file) => {
      if (file.type == 2) {
        hasImage = true;
      }
    });

    return hasImage;
  };


  return (
    <div key={message.id} className={"kil-chat-widget-conversation-message" + (message.fromClient ? ' client' : '') + (message.fromClient && hasImage() ? ' client-image' : '') }>
      <div className="kil-chat-widget-conversation-message-div">
        <div className="kil-chat-widget-conversation-message-sender">
          {message.bot &&
            <>
            {message.user.name},{'\u00A0'}
            </>
          }
          {!message.fromClient && !message.bot &&
            <>
            {message.user.name},{'\u00A0'}
            </>
          }
          {message.fromClient &&
            <>
            {t('You')},{'\u00A0'}
            </>
          }
          <DateFormater>{message.date}</DateFormater>
        </div>
        <div className="kil-chat-widget-conversation-message-div-msg">
          <LinkItUrl>
            {message.message}
          </LinkItUrl>

          {message.imagePreview &&
            <FileImagePreview file={message.imagePreview} message={message} i="0" />
          }

          {message.files.length > 0 &&
            <>
            {message.files.map((file, i) => (
              <File key={file.id} file={file} message={message} i={i} />
            ))}
            </>
          }

        </div>
      </div>
      {message.actionButtons !== undefined && message.actionButtons.length > 0 &&
            <ActionButtons message={message} />
          }
    </div>
  );
}

export default Message;